import { DateRangeType } from 'modules/dashboard/types/phlebotomist-dashboard';

import { PeriodType } from '../types';

export function getHistoryConfig(
  dateRange: DateRangeType,
  isQuarterly: boolean
): { periodType: PeriodType; bars: number } {
  if (isQuarterly) return { periodType: 'quarterCal', bars: 4 };
  switch (dateRange) {
    case 'day':
      return { periodType: 'dayCal', bars: 30 };
    case 'week':
      return { periodType: 'week', bars: 12 };
    case 'month':
      return { periodType: 'month', bars: 12 };
    case 'quarter':
      return { periodType: 'quarter', bars: 4 };
    case 'year':
      return { periodType: 'year', bars: 12 };
    case 'yesterday':
    case 'yesterdayCal':
      return { periodType: 'dayCal', bars: 30 };
    case 'lastWeek':
    case 'weekCal':
    case 'lastWeekCal':
      return { periodType: 'weekCal', bars: 12 };
    case 'lastQuarter':
    case 'quarterCal':
    case 'lastQuarterCal':
      return { periodType: 'quarterCal', bars: 4 };
    case 'lastYear':
    case 'yearCal':
    case 'pYearCal':
      return { periodType: 'monthCal', bars: 12 };
    case 'lastMonth':
    case 'monthCal':
    case 'lastMonthCal':
    default:
      return { periodType: 'monthCal', bars: 12 };
  }
}
